module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/aback9-5398c278dcfdda937ce6b6aecf05f877.jpg";